import React, { InputHTMLAttributes, forwardRef } from "react";

interface SwitchCardProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  description?: string;
}

export const SwitchCard = forwardRef<HTMLInputElement, SwitchCardProps>(
  function SwitchCard({ label, description, className, ...input }, ref) {
    return (
      <label className="vz-switch-card d-flex align-items-center justify-content-between gap-3">
        <span style={{ minWidth: 0 }}>
          <span className="d-block fw-semibold" style={{ fontSize: 13 }}>
            {label}
          </span>
          {description && (
            <span className="d-block text-muted" style={{ fontSize: 12 }}>
              {description}
            </span>
          )}
        </span>
        <input type="checkbox" ref={ref} className="vz-sr-only" {...input} />
        <span className="vz-switch-track" aria-hidden>
          <span className="vz-switch-thumb" />
        </span>
      </label>
    );
  },
);

interface ChipCheckProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

/** Multi-choice option: a pill that fills with a ✓ when selected */
export const ChipCheck = forwardRef<HTMLInputElement, ChipCheckProps>(
  function ChipCheck({ label, ...input }, ref) {
    return (
      <label className="vz-chip-check mb-0">
        <input type="checkbox" ref={ref} className="vz-sr-only" {...input} />
        <span className="vz-chip-body">
          <span className="vz-chip-tick">✓</span>
          {label}
        </span>
      </label>
    );
  },
);
